import React, { useState } from 'react';
import CustomerTable from './CustomerTable';
import CustomerForm from './CustomerForm';

const Customers = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);

  const handleAddCustomer = () => {
    setEditingCustomer(null); // Clear any editing state
    setShowForm(true);
  };

  const handleEditCustomer = (customer) => {
    setEditingCustomer(customer); // Set the customer to edit
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditingCustomer(null); // Clear editing state after success
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingCustomer(null); // Clear editing state on cancel
  };

  return (
    <>
      {showForm ? (
        <CustomerForm 
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
          customer={editingCustomer} // Pass the customer to edit
        />
      ) : (
        <CustomerTable 
          onAddCustomer={handleAddCustomer} 
          onEditCustomer={handleEditCustomer} // Pass the edit handler
        />
      )}
    </>
  );
};

export default Customers;